import { Currency, NotificationsToast } from '@tdwb/core';

import { Strategy, PricePlan } from '@tdwb/lazy/trading';

export interface OrderNotificationsToast extends NotificationsToast {
  isComplex?: boolean;
  isRejected?: boolean;
  accountNumber?: string;
  symbol?: string;
  strategy?: Strategy;
  quantity?: number;
  dollarAmt?: number;
  price?: number;
  action?: OrderNotificationsToastAction;
  priceType?: PricePlan;
  accountTypeDescription?: string;
  accountCurrency?: Currency;
  items?: Array<OrderNotificationsToastItem>;
}

export interface OrderNotificationsToastItem {
  symbol?: string;
  quantity?: number;
  price?: number;
  action?: OrderNotificationsToastAction;
  priceType?: PricePlan;
}

export enum OrderNotificationsToastAction {
  BUY = 'BUY',
  BOUGHT = 'BOUGHT',
  SELL = 'SELL',
  SOLD = 'SOLD',
  UNKNOWN = 'UNKNOWN'
}
